import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { AdvancedImage } from "@cloudinary/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Margin } from "@mui/icons-material";

const CsrGallery = ({ galleryImages }) => {
  return (
    <div className="bs-section bs-section--typ-csr-gallery">
      <div className="bs-section__section-cont">
        <div className="bs-csr-gallery-layout">
          {/* Header with Navigation */}
          <div className="bs-csr-gallery-layout__header">
            <button
              className="bs-csr-gallery-layout__nav-prev"
              aria-label="Previous image"
            >
              <span className="icon arrow-left"></span>
            </button>
            <h2 className="bs-csr-gallery-layout__title">IMAGE GALLERY</h2>
            <button
              className="bs-csr-gallery-layout__nav-next"
              aria-label="Next image"
            >
              <span className="icon arrow-right"></span>
            </button>
          </div>

          {/* Swiper Gallery */}
          <div className="bs-csr-gallery-layout__swiper-container">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              navigation={{
                prevEl: ".bs-csr-gallery-layout__nav-prev",
                nextEl: ".bs-csr-gallery-layout__nav-next",
              }}
              pagination={{
                clickable: true,
                el: ".bs-csr-gallery-layout__pagination",
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              loop={true}
              breakpoints={{
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                },
              }}
              className="bs-csr-gallery-layout__swiper"
            >
              {galleryImages.map((image, index) => (
                <SwiperSlide
                  key={image.id || index}
                  className="bs-csr-gallery-layout__slide"
                >
                  <div className="bs-csr-gallery-layout__image-container">
                    <AdvancedImage
                      cldImg={image.cloudinaryImage}
                      alt={image.alt}
                      className="bs-csr-gallery-layout__image"
                      loading="lazy"
                      onError={(e) => {
                        e.currentTarget.onerror = null; // prevents looping
                        e.currentTarget.src = "https://res.cloudinary.com/dci1aiukm/image/upload/v1761118556/sansaar-placeholder.webp";
                      }}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Custom Pagination */}
            {/* <div className="bs-csr-gallery-layout__pagination"></div> */}
            
          </div>

          {/* Gallery Description */}
          <div className="bs-csr-gallery-layout__description">
            <h3 className="bs-csr-gallery-layout__title" style={{fontSize : "30px",  paddingTop:"0"} }>
              AT SANSAAR, CONSCIOUS LIVING GOES BEYOND CREATING BEAUTIFUL,
              COMFORTABLE SPACES.
            </h3>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default CsrGallery;
